import React, { useEffect, useMemo, useState } from 'react';  
import Header from '../Header/Header';
import BannerSimple from '../BannerSimple/BannerSimple';
import { trackScorm } from '../../scormRuntime/ScormTracker';
import './styles.less';

const LessonScormWindow = ( { learningObject, course, courseOptions } ) => {  
    const [ isTracking, setIsTracking ] = useState( false ); 
    
     // Get the scorm URL
    const url = useMemo( () => {
        const originalURL = learningObject.content.url;
        const origin = `${ window.location.origin }/`;
        let url = originalURL.replace( /(https:|)(^|\/\/)(.*?\/)/g, origin );
        
        /***********************************
         * Test Courses
         * 
         * Uncomment one of these lines to
         * test a course locally.
         * 
         * Also, you can change 
         * START_COURSE_AS_NEW to true
         * so all courses start as if they
         * have never been run.
         ***********************************/
            
        // Chamelean scorm 1.2 courses
        //url = 'http://localhost:3126/test-bourne-course/';    
        //url = 'http://localhost:3126/test-camelean-course/'; 
        //url = 'http://localhost:3126/chameleon4short/';                  
            
        // Chamelean scorm 2004 courses
        //url = 'http://localhost:3126/jdd-lizard-test-2004v4/index.html'; 
            
        // Rise scorm 1.2 courses
        //url = 'http://localhost:3126/single-vision-rise/scormdriver/indexAPI.html';
        //url = 'http://localhost:3126/rx-rise/scormdriver/indexAPI.html';
        //url = 'http://localhost:3126/rise-hygine/scormdriver/indexAPI.html';    
            
        const localeQuery = `?language=${ courseOptions.locale }`;
        return `${ url }${ localeQuery }`;

    }, [ learningObject ] );

    // Start the scorm tracker
    useEffect( () => {
        if ( url && learningObject && course && courseOptions ) { 
            trackScorm( course, learningObject, courseOptions.studentName, 
                courseOptions.studentId, courseOptions.token ); 
            setIsTracking( true ); 
        } 
    }, [ url, course, learningObject, courseOptions ] );

    // Load the theme
    useEffect( () => {
        if ( courseOptions.theme ) {
            const link = document.createElement( 'link' );            
                
            link.id = 'theme-css';
            link.rel = 'stylesheet';
            link.type = 'text/css';
            link.href = courseOptions.theme;
                
            const head = document.getElementsByTagName( 'HEAD' )[ 0 ];
            head.appendChild( link );    
        }
    }, [ courseOptions ] );

    return (
        <div className="lesson-scorm-window">
            <Header />
            
            <BannerSimple text={ course.name }/>

            <div className="main-content">

                { /* Breadcrumbs */ }
                <nav className="breadcrumbs ">
                    <ol>
                        {
                            courseOptions.breadcrumbs.map( i =>  
                                <li key={ i.link }>
                                    <span>
                                        <a href={ `${ courseOptions.referer }${ i.link }` }>
                                            { i.title }
                                        </a>
                                    </span>

                                    <span className="separator">&gt;</span>
                                </li>
                            )
                        }
                        <li>
                            <span>{ course.name }</span>
                        </li>
                    </ol>
                </nav>

                { /* SCORM iframe */ }
                { isTracking && 
                    <div className="iframe-parent">
                        <iframe 
                            className="iframe-center"
                            frameBorder="0"
                            src={ url }
                        />
                    </div>
                }
            </div>
        </div>
    );
};

export default LessonScormWindow;
